module.exports = __webpack_public_path__ + "img/rosen33.6d9f135d.png";